import Http from './../http';

const prefix = '/layout';

const removeEmpty = obj => {
  Object.keys(obj).forEach(k => {
    if (typeof obj[k] === 'object') removeEmpty(obj[k]);
    else return !obj[k] && obj[k] !== undefined && delete obj[k];
  });
  return obj;
};

export const getLayouts = website_id => {
  return Http.authApi().get(`${prefix}/${website_id}`);
};

export const get = id => {
  return Http.authApi().get(`${prefix}/${id}`);
};

export const create = layout => {
  return Http.authApi().post(`${prefix}`, removeEmpty(layout));
};

export const edit = layout => {
  return Http.authApi().put(`${prefix}/${layout.encrypted_id}`, layout);
};

export const exclude = layout => {
  return Http.authApi().delete(`${prefix}/${layout.encrypted_id}`, layout);
};



// WEBPACK FOOTER //
// ./src/js/services/editor/layout.js